import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Node.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "li",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.shouldBeDisplayedInSearchResults,
          expression: "shouldBeDisplayedInSearchResults"
        }
      ]
    },
    [
      _c(
        "Label",
        {
          attrs: { node: _vm.node, hovered: _vm.hovered, level: _vm.level },
          nativeOn: {
            mouseenter: function($event) {
              _vm.$emit("highlight", _vm.node.id.toString());
            }
          },
          model: {
            value: _vm.checked,
            callback: function($$v) {
              _vm.checked = $$v;
            },
            expression: "checked"
          }
        },
        [
          _vm.hasChildNodes
            ? _c(
                "div",
                {
                  staticClass: "icon",
                  attrs: { slot: "chevron", expanded: _vm.isExpanded },
                  on: {
                    click: function($event) {
                      _vm.$emit("toggle-expand", _vm.node.id.toString());
                    }
                  },
                  slot: "chevron"
                },
                [_c("ChevronRightIcon")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("label", [
            _vm._v("\n            " + _vm._s(_vm.node.label) + "\n        ")
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isExpanded,
              expression: "isExpanded"
            }
          ],
          staticClass: "sub-tree"
        },
        _vm._l(_vm.node.children, function(child) {
          return _c("Node", {
            key: child.id,
            attrs: {
              selected: _vm.selected,
              node: child,
              ancestors: _vm.parentNodes,
              parent: _vm.node,
              level: _vm.level + 1,
              "expand-level": _vm.expandLevel,
              current: _vm.current,
              hovered: _vm.hovered,
              expanded: _vm.expanded,
              search: _vm.search
            },
            on: {
              "toggle-expand": _vm.onToggleExpand,
              input: _vm.onSelect,
              expand: _vm.onExpand,
              highlight: _vm.onHover
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function(ref) {
                    var node = ref.node;
                    return [_vm._t("label", null, { node: node })]
                  }
                }
              ],
              null,
              true
            )
          })
        }),
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-260b0c2e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Tree/Node.vue.js